import gql from 'graphql-tag';

export default gql`
  mutation toggleQueueMutation($input: RelayTogglePauseQueueInput!) {
    toggleQueue(input: $input) {
      success
    }
  }
`;
